define('models/modals/filter/index',['require','models/filter/index','models/base/modal'],function(require) {
    'use strict';

    var FilterModel = require('models/filter/index'),
        ModalModel = require('models/base/modal');

    var FilterModalContent = FilterModel.extend({
    });

    var FilterModalModel = ModalModel.extend({
        defaults: {
            'title': 'Фильтр',
            'buttons': [
                { caption: 'Сохранить', className: 'btn-warning pull-left', 'action': 'save' },
                { caption: 'Сбросить', className: 'btn-danger', 'action': 'reset' },
                { caption: 'Применить', className: 'btn-success', 'action': 'apply' },
                { caption: 'Отмена', className: '', 'action': 'cancel' }
            ],
            body: ''
        },
        constructor: function() {
            ModalModel.apply(this, arguments);
            this.content = new FilterModalContent();
        },
        dispose: function() {
            if (this.disposed) { return; }
            this.content.dispose();
            ModalModel.prototype.dispose.apply(this, arguments);
        }
    });

    return FilterModalModel;
});
